import { Typography } from "@mui/material";
import React from "react";
import Gene20Box from "../../Gene20Box/Gene20Box";

export default function CopyRights() {
  return (
    <Gene20Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
      color="light"
      // px={1.5}
    >
      <Typography variant="body1" sx={{ fontVariant: "small-caps" }}>
        &nbsp; igugu empire projects &nbsp;
      </Typography>
      <Typography variant="body1" sx={{ fontVariant: "all-small-caps" }}>
        &copy; {new Date().getFullYear()}
      </Typography>
    </Gene20Box>
  );
}
